import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }

import { reactive, onMounted, ref, unref } from 'vue';
import { useRouter } from 'vue-router';

import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useDictionary } from '@/store/dictionary.store';
import { useLocales } from '@/hooks/useLocales';

import { formatTools } from '@/utils/index';
import { CtSubmitApi, DeleteDraftListApi, GetContractDraftList } from '@/apis/contract/contract.api';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ContractSubmitApi } from '@/apis/contract/contract.draft.api';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();
const { getName } = useDictionary();
const { push } = useRouter();
const { fDate, fDateTime } = formatTools();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetContractDraftList,
	delListApi: DeleteDraftListApi,
	response: { data: 'data', total: 'total' },
});

/* 数据Table绑定设置 */
const tabColumns = reactive<any[]>([
	{ field: 'no', label: t('contractList.form.contractNo', '合同编号'), columnWidth: '120' },
	{ field: 'name', label: t('contractList.form.contractName', '合同名称'), columnWidth: '200' },
	{ field: 'plan_a_name', label: t('contractList.table.ourParty', '我方主体'), columnWidth: '200' },
	{ field: 'counterpart_name', label: t('contractList.table.counterpart', '相对方'), columnWidth: '200' },
	{ field: 'category_name', label: t('draft.contractCategory', '合同分类') },
	{ field: 'time_limit', label: t('draft.contractTerm', '合同期限'), columnWidth: '200', align: 'center' },
	{ field: 'contract_amount', label: t('draft.contractAmount', '合同金额'), columnWidth: '100', align: 'right' },
	{ field: 'contract_source', label: t('draft.signingSource', '签订来源'), columnWidth: '100', align: 'center' },
	{ field: 'created_time', label: t('draft.createdTime', '创建时间'), columnWidth: '120', align: 'center' },
	{ field: 'action', width: '160px', label: t('contractList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const state = reactive({
	loading: false,
	search: { work_type: 1 } as any,
	paged: { current: 1, page_size: 10 },
});

const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	/* 重置查询条件 */
	reSetSearch: () => {
		state.search = { work_type: 1 };
		methods.resetParams(state.search);
	},
	/* 预览 */
	preview: (row: any) => {
		push({ path: `/contracts/previews`, query: { contractId: `${row.id}` } });
	},
	/* 创建草稿 */
	create: () => {
		push({ path: '/contracts/drafteditor' });
	},
	/* 编辑 */
	editor: (row: any) => {
		push({ path: '/contracts/drafteditor', query: { contractId: row.id } });
	},
	/* 提交合同 */
	submit: (row: any) => {
		ElMessageBox.confirm(t('contractList.confirm.submitMessage', '是否提交选中的数据？'), t('contractList.confirm.submitTitle', '提示'), { lockScroll: false, confirmButtonText: t('contractList.confirm.submitConfirm', '提交'), cancelButtonText: t('contractList.confirm.submitCancel', '取消'), type: 'warning' }).then(() => {
			tableObject.loading = true;

			const onSuccess = (res: any) => {
				const { succeeded, errors } = res;
				if (!succeeded) {
					ElMessage.error(`提交失败！可能的原因：${errors}`);
				} else {
					ElMessage.success('提交成功');
				}
			};

			const onFail = (err: any) => {
				ElMessage.error(err.message);
			};

			const onFinally = () => {
				tableObject.loading = false;
				actions.search();
			};

			ContractSubmitApi(row).then(onSuccess).catch(onFail).finally(onFinally);
		});
	},

	/* 删除草稿 */
	delete: async (row: any) => {
		const deleteDto = { id: row.id, revision: row.revision };
		await methods.deleteRows(deleteDto);
	},
};

onMounted(async () => {
	actions.search();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "naver",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(state).search,
          ref: "queryFormRef",
          size: "small",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('contractList.form.contractNo', '合同编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.ct_no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.ct_no) = $event)),
                  clearable: "",
                  placeholder: _unref(t)('contractList.form.contractNo', '请输入合同编号')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('contractList.form.contractName', '合同名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.ct_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.ct_name) = $event)),
                  clearable: "",
                  placeholder: _unref(t)('contractList.form.contractName', '请输入合同名称')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: "Search",
                      onClick: actions.search
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { icon: "DocumentCopy" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.createFromTemplate', '从模板创建')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: "Plus",
                      onClick: actions.create
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.createContract', '创建草稿')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "naver",
      class: "mgt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          contract_amount: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.contract_amount.toLocaleString('zh')), 1)
          ]),
          time_limit: _withCtx(({ row }) => [
            (row.contract_limit == 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(fDate)(row.begin_day)) + " ~ " + _toDisplayString(_unref(fDate)(row.end_day)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(fDate)(row.begin_day)) + " ~ " + _toDisplayString(_unref(fDate)(row.end_day, '无固定期限')), 1)
                ], 64))
          ]),
          contract_source: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, { size: "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('contract_source', row.contract_source)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          created_time: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(fDateTime)(row.created_time)), 1)
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                link: "",
                onClick: ($event: any) => (actions.preview(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.detail', '详细')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "success",
                size: "small",
                link: "",
                onClick: ($event: any) => (actions.editor(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('buttons.modify', '修改')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_dropdown, {
                style: {"padding":"2px","margin-left":"12px"},
                trigger: "click",
                size: "small"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            link: "",
                            type: "primary",
                            onClick: ($event: any) => (actions.submit(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.submitContract', '提交合同')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            link: "",
                            type: "danger",
                            onClick: ($event: any) => (actions.delete(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.deleteContract', '删除合同')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    })
  ], 64))
}
}

})